import { render } from "./PartnerFinder.vue?vue&type=template&id=2e80652e&scoped=true"
import script from "./PartnerFinder.vue?vue&type=script&lang=js"
export * from "./PartnerFinder.vue?vue&type=script&lang=js"

import "./PartnerFinder.vue?vue&type=style&index=0&id=2e80652e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\LifeInsureance\\web\\LifeInsurance\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e80652e"]])

export default __exports__